import { environment } from "src/environments/environment";

export const BASE_URL = environment.apiBase;
export const END_POINTS = {
    WORK_ORDER: {
        FETCH: `/workorder/get`,
        FETCH_BY_ID: (id: number) => `/workorder/get/${id}`,
        FETCH_APPROVED: `/workorder/approved`,
        FETCH_APPROVED_BY_ID: (id: number) => `/workorder/approved?boq=true&siteKey=${id}`,
        CREATE: `/workorder/create`,
        APPROVE: (id: number) => `/workorder/approve/${id}`,
        REJECT: (id: number) => `/workorder/reject/${id}`,
        UPDATE: (id: string) => `/workorder/update/${id}`,
        DELETE: (id: string) => `/workorder/delete/${id}`,
        GET_AMENDMENT: `/workorder/amendmend`,
        AMENDMENT_BY_ID: (id: number) => `/workorder/amendmend/${id}`,
        CREATE_AMENDMENT: `/workorder/amendmend`,
        UPDATE_AMENDMENT: (id: string) => `/workorder/amendmend/${id}`,
        AMENDMENT_APPROVE: (id: number) => `/workorder/amendmend/approve/${id}`,
        AMENDMENT_REJECT: (id: number) => `/workorder/amendmend/reject/${id}`,
        UPLOAD: (id: number) => `/workorder/upload/${id}`,
        FETCH_BY_SITEKEY: (id: string) => `/workorder/get?siteKey=${id}`,
        FETCH_FOR_SITEBUDGET: (id: string) => `/workorder/get?forSiteBudget=true&siteKey=${id}`,
        FETCH_BY_SITE_BOQ_CREATE_WO:(id:string) =>`/workorder/approved?boq=true&siteKey=${id}`,
        PRINT: (id: number) => `/export/workorder/${id}`
    },
    BOQ_ENTRY: {
        FETCH: (page: Number)=> `/boqentry/get?page=${page}`,
        SEARCH: (page: Number, search: string)=> `/boqentry/get?page=${page}&search=${search}`,
        APPROVE: (id: number) => `/boqentry/approove/${id}`,
        REJECT: (id: number) => `/boqentry/reject/${id}`,
        CREATE: `/boqentry/create`,
        UPDATE: (id: number) => `/boqentry/update/${id}`,
        FETCH_BOQ_DETAIL_BY_ID: (boqId: number) => `/boqentry/boq/${boqId}/boqdetails`,
        FETCH_BOQ_CODE_BY_ID: (boqId: number) => `/boqentry/boq/${boqId}/boq-codes`,
        FETCH_PRODUCTS_BY_BOQ_CODE_ID: (boqId: number) => `/boqentry/boq/${boqId}/wo-details`,
        IMPORT: (workOrderKey: number) => `/boqentry/upload/workorder/${workOrderKey}/boq`,
        FETCH_BY_ID: (id: number) => `/boqentry/get/${id}`,
        FETCH_AMENDMENT: `/amendment/boqamend/get`,
        FETCH_AMENDMENT_BY_KEY: (boqId: number) => `/amendment/boqamend/get/${boqId}`,
        CREATE_AMENDMENT: (id: number) => `/amendment/${id}`,
        UPDATE_AMENDMENT: (id: number) => `/amendment/${id}`,
        APPROVE_AMENDMENT: (id: number) => `/amendment/approove/${id}`,
        REJECT_AMENDMENT: (id: number) => `/amendment/reject/${id}`,
        FETCH_AMENDMENT_BOQ_DETAIL_BY_ID: (boqId: number) => `/amendment/${boqId}/boqdetails`,
        PRINT: (id: number) => `/export/boq/${id}`,
    },
    WORK_TYPE: {
        FETCH: `/worktype/all`
    },
    PRN_ENTRY: {
        FETCH: `/prnentry/get`,
        FETCH_BY_ID: (id: number) => `/prnentry/get/${id}`,
        CREATE: `/prnentry/create`,
        UPDATE: (id: number) => `/prnentry/update/${id}`,
        APPROVE: (id: any) => `/prnentry/approve/${id}`,
        REJECT: (id: any) => `/prnentry/reject/${id}`,
        DELETE: (id: any) => `/prnentry/delete/${id}`,
        FETCH_BY_SITEKEY: (id: string) => `/prnentry/get-by-site?siteKey=${id}`,
        FETCH_BY_SITEKEY_FOR_PO: (id: string) => `/prnentry/get-by-site?siteKey=${id}&forPo=true`,
        FETCH_ALL_BY_SITEKEY: (id: string) => `/prnentry/get-all-site-prn?siteKey=${id}`,
        FETCH_PRODUCT_CODE_BY_PRN_IDS: `/prnentry/purchase/prn`,
        FETCH_PRODUCT_CODE_BY_PRN_IDS_QE: `/prnentry/purchase/prn?forEdit=true`,
        PRINT: (id: number) => `/export/prnentry/${id}`,
        GET_PRINT: (id: number) => `/prnentry/get-print/${id}`,
    },
    STOCK: {
        UPLOAD: `/stock/openingstock`,
        FETCH: `/stock/get`,
        FETCH_BY_ID: (id: number) => `/stock/get/${id}`,
        CREATE: `/stock/create`,
        UPDATE: (id: number) => `/stock/update/${id}`,
        FETCH_BY_PRODUCT: `/stock/getStockByProduct`,
    },
    STOCKADJUSTMENT: {
        FETCH: `/stockadjustment/get`,
        FETCH_BY_ID: (id: number) => `/stockadjustment/get/${id}`,
        CREATE: `/stockadjustment/create`,
        UPDATE: (id: number) => `/stockadjustment/update/${id}`,
        FETCH_BY_PRODUCT: `/stockadjustment/getStockByProduct`,
        APPROVE: (id: any) => `/stockadjustment/approve/${id}`,
        REJECT: (id: any) => `/stockadjustment/reject/${id}`,
    },
    GRN_ENTRY: {
        FETCH: `/grn/get`,
        FETCH_BY_ID: (id: number) => `/grn/get/${id}`,
        FETCH_DETAILS_BY_ID: (id: number) => `/grn/getDetailsById?id=${id}`,
        CREATE: `/grn/create`,
        UPDATE: (id: number) => `/grn/update/${id}`,
        APPROVE: (id: any) => `/grn/approve/${id}`,
        REJECT: (id: any) => `/grn/reject/${id}`,
        PRINT: (id: number, type:string) => `/export/grn/${id}?type=${type}`,
        FETCH_SITE_FOR_DO :`/grn/deliveryOrderSite`,
        FETCH_FOR_DO: `/grn/deliveryOrder`,
        FETCH_PRODUCT_FOR_DO : `/grn/getProductDetailsForDO`
    },
    EXPENSE_ENTRY:{
        APPROVE: (id: any) => `/expensedata/approve/${id}`,
        REJECT: (id: any) => `/expensedata/reject/${id}`,
    },
    PURCHASE_ORDER: {
        FETCH: `/purchaseorder/all`,
        FETCH_BY_ID: (id: number) => `/purchaseorder/get?id=${id}`,
        FETCH_BY_SUPPLIER: (id: number) => `/purchaseorder/all?supplierKey=${id}`,
        CREATE: `/purchaseorder/create`,
        UPDATE: (id: number) => `/purchaseorder/update/${id}`,
        APPROVE: (id: number) => `/purchaseorder/approve/${id}`,
        REJECT: (poId: any) => `/purchaseorder/reject/${poId}`,
        FORCECLOSE: (poId: any) => `/purchaseorder/forceclose/${poId}`,
        PRINT: (id: number) => `/export/po/${id}`,
        FETCH_FOR_DO: `/purchaseorder/deliveryOrder`,
        FETCH_SITE_FOR_DO: `/purchaseorder/deliveryOrderSite`,
        FETCH_PRODUCT_FOR_DO : `/purchaseorder/getProductDetailsForDO`,
        FETCH_DETAILS_BY_ID :(id:number) => `/purchaseorder/getDetailsById?forGrn=true&id=${id}`
    },
    DELIVERY_ORDER: {
        FETCH: `/do/all`,
        FETCH_BY_ID: (id: number) => `/do/get/${id}`,
        CREATE: `/do/create`,
        UPDATE: (id: number) => `/do/update/${id}`,
        APPROVE: (id: number) => `/do/approve/${id}`,
        REJECT: (id: any) => `/do/reject/${id}`,
        PRINT: (id: number) => `/export/do/${id}`,
        FETCH_FOR_DO: `/do/deliveryOrder`,
        FETCH_PRODUCT_FOR_DO : `/do/getProductDetailsForDO`,
        FETCH_DELIVERED_QUANTITY: `/do/getDetailsById`,
    },

    LOI: {
        FETCH: `/loi/all`,
        FETCH_BY_ID: (id: number) => `/loi/get?id=${id}`,
        CREATE: `/loi/create`,
        UPDATE: (id: number) => `/loi/update/${id}`,
        APPROVE: (id: number) => `/loi/approve/${id}`,
        REJECT: (id: any) => `/loi/reject/${id}`,
    },

    GST: {
        FETCH: `/gst_master/all`
    },
    TOWER: {
        FETCH_ALL : `/tower/all`,
    },
    TERMS: {
        FETCH: `/epterms/all`,
        FETCH_BY_TYPE:(type: string)=> `/epterms/all?type=`+type
    },
    SUPPLIER_BILL:{
        FETCH: `/purchaseinvoice/all`,
        FETCH_BY_ID: (id: number) => `purchaseinvoice/get?id=${id}`,
        CREATE: `/purchaseinvoice/create`,
        UPDATE: (id: number) => `/purchaseinvoice/update/${id}`,
        APPROVE: (id: number) => `/purchaseinvoice/approve/${id}`,
        REJECT: (id: any) => `/purchaseinvoice/reject/${id}`,
    },

     SUPPLIER_PAYMENT:{
        FETCH: `/supplier-advance-payment/all`,               
        FETCH_BY_ID: (id: number) => `/supplier-advance-payment/get?id=${id}`,
        CREATE: `/supplier-advance-payment`,
        UPDATE: (id: number) => `/supplier-advance-payment/${id}`,
        APPROVE: (id: number) => `/supplier-advance-payment/approve/${id}`,
        REJECT: (id: any) => `/supplier-advance-payment/reject/${id}`,
    },  

    SUPPLIER_PAYMENT_PLANNING: {
        FETCH: `/supplier-payment-planning/all`,
        FETCH_BY_ID: (id: number) => `/supplier-payment-planning/get?id=${id}`,
        CREATE: `/supplier-payment-planning/create`,
        UPDATE: (id: number) => `/supplier-payment-planning/update/${id}`,
        SUBMIT_FOR_APPROVAL: (id: number) => `/supplier-payment-planning/submit-for-approval/${id}`,
        APPROVE: (id: number) => `/supplier-payment-planning/approve/${id}`,
        REJECT: (id: any) => `/supplier-payment-planning/reject/${id}`,
    },
    
    PAYMENT_PROCESSING: {
        FETCH: `/payment-processing/all`,
        FETCH_BY_ID: (id: number) => `/payment-processing/get?id=${id}`,
        PROCESS: (id: number) => `/payment-processing/process/${id}`,
        HOLD: (id: number) => `/payment-processing/hold/${id}`,
        ADVICE: (id: number) => `/payment-processing/advice/${id}`,
    },

    CONTRACTOR_PAYMENT:{
        FETCH: `/contractor-advance-payment/all`, 
        CREATE: `/contractor-advance-payment`,
        UPDATE: (id: number) => `/contractor-advance-payment/${id}`,
        APPROVE: (id: number) => `/contractor-advance-payment/approve/${id}`,
        REJECT: (id: any) => `/contractor-advance-payment/reject/${id}`,
    }, 

    CONTRACTOR_PAYMENT_PLANNING: {
        FETCH: `/contractor-payment-planning/all`,
        FETCH_BY_ID: (id: number) => `/contractor-payment-planning/get?id=${id}`,
        CREATE: `/contractor-payment-planning/create`,
        UPDATE: (id: number) => `/contractor-payment-planning/update/${id}`,
        SUBMIT_FOR_APPROVAL: (id: number) => `/contractor-payment-planning/submit-for-approval/${id}`,
        APPROVE: (id: number) => `/contractor-payment-planning/approve/${id}`,
        REJECT: (id: any) => `/contractor-payment-planning/reject/${id}`,
    },

    TDS_PAYMENT:{
        CREATE: `/contractor-tds-payment`,
        APPROVE: (id: number) => `/contractor-tds-payment/approve/${id}`,
        REJECT: (id: any) => `/contractor-tds-payment/reject/${id}`,
    },

    RETENTION_PAYMENT:{
        CREATE: `/contractor-retention-payment`,
        UPDATE: (id: number) => `/contractor-retention-payment/${id}`,
        APPROVE: (id: number) => `/contractor-retention-payment/approve/${id}`,
        REJECT: (id: any) => `/contractor-retention-payment/reject/${id}`,
    },

    CLIENT_RECEIPT_PAYMENT:{
        CREATE: `/client-receipt-payment`,
        UPDATE: (id: number) => `/client-receipt-payment/${id}`,
        APPROVE: (id: number) => `/client-receipt-payment/approve/${id}`,
        REJECT: (id: any) => `/client-receipt-payment/reject/${id}`,
    }, 

    EXPORT_CSV: {
        EXPORT: (module: string) => `/export/csv/${module}`
    },

    EXPORT_CONTRACTORWO:{
       EXPORT: `/sub-contractor-wo?export=true`,
    },

    DASHBOARD:{
        FETCH: `/dashboard/getDashboardCount`,
    },

    SubWORK_ORDER: {
        CREATE: `/sub-contractor-wo`,
        UPDATE: (id: string) => `/sub-contractor-wo/${id}`,
        FETCH_BY_ID: (id: number) => `/sub-contractor-wo/${id}`,
        FETCH_Contractor_Site_ID: (id: number) => `/sub-contractor-wo/status?contractor=true&siteKey=${id}`,
        FETCH_SubWO_Contractor_ID: (id: number) => `/sub-contractor-wo/status?contractor=false&forTrans=true&contractorKey=${id}&&status=APPROVED`,
        APPROVE: (id: number) => `/sub-contractor-wo/approve/${id}`,
        REJECT: (id: any) => `/sub-contractor-wo/reject/${id}`,
        FETCH_SUBWO_DETAILS_BY_ID:(id: number) =>`/sub-contractor-wo/wo-codes/${id}?forEdit=true`,
        FETCH_SubWO_Contractor_ID_ForBill: (id: number) => `/sub-contractor-wo/status?contractor=false&forTrans=true&forBillEntry=true&contractorKey=${id}&forEdit=true&&status=APPROVED`,
        FETCH_Issue_SubWO_Contractor_ID: (id: number) => `/sub-contractor-wo/status?contractor=false&forTrans=false&contractorKey=${id}&&status=APPROVED`,
        FETCH_WO_FOR_EDIT_ISSUE:(id:number)=> `/sub-contractor-wo/status?contractor=false&contractorKey=${id}&forBillEntry=false&forEdit=true&forTrans=true&status=APPROVED`,
        PRINT: (id: number) => `/export/sub-con-wo/${id}`
    },

    issue_Material:{
        CREATE: `/mat-sc-wo`,
        UPDATE: (id: string) => `/mat-sc-wo/${id}`,
        FETCH_BY_ID: (id: number) => `/mat-sc-wo/${id}`,
        APPROVE: (id: number) => `/mat-sc-wo/approve/${id}`,
        REJECT: (id: any) => `/mat-sc-wo/reject/${id}`,
        PRINT: (id: number) => `/export/issue-material/${id}`
    },

    stock_consumption:{
        CREATE: `/stock-consumption`,
        UPDATE: (id: string) => `/stock-consumption/${id}`,
        FETCH_BY_ID: (id: number) => `/stock-consumption/${id}`,
        APPROVE: (id: number) => `/stock-consumption/approve/${id}`,
        REJECT: (id: any) => `/stock-consumption/reject/${id}`,
    },

    contractor_bill_entry:{
        CREATE: `/contractor-bill-entry`,
        UPDATE: (id: string) => `/contractor-bill-entry/${id}`,
        FETCH_BY_ID: (id: number) => `/contractor-bill-entry/${id}`,
        APPROVE: (id: number) => `/contractor-bill-entry/approve/${id}`,
        REJECT: (id: any) => `/contractor-bill-entry/reject/${id}`,
        PRINT: (id: number) => `/export/contractor-bill-entry/${id}`
    },
    UPLOAD_DOCUMENT:{
        UPLOAD: (id: number,module:any) => `/upload/${id}/${module}`,
        GETUPLOADFILE :(id: number,module:any) => `/upload/${id}/${module}`, 
        DOWNLOADFILE : (module:any,fileName:any) => `/upload/${module}?fileName=${fileName}`, 
        DELETEFILE : (module:any,fileName:any) => `/upload/${module}?fileName=${fileName}`,
        UPDATEFILE : (id:number,fileName:any) => `/upload/${id}/${module}/fileName=${fileName}`,
    },

     QUOTATION_REQUEST: {
        FETCH_BY_ID: (id: number) => `/quotation/${id}`,
        CREATE: `/quotation`,
        UPDATE: (id: number) => `/quotation/${id}`,
        APPROVE: (id: number) => `/quotation/approve/${id}`,
        REJECT: (poId: any) => `/quotation/reject/${poId}`,
        PRINT: (id: number) => `/export/quotation-request/${id}`,
       
    },

    QUOTATION_ENTRY: {
        FETCH_BY_ID: (id: number) => `/quotation-entry/get/${id}`,
        CREATE: `/quotation-entry/create`,
        UPDATE: (id: number) => `/quotation-entry/update/${id}`,
        APPROVE: (id: number) => `/quotation-entry/approve/${id}`,
        REJECT: (poId: any) => `/quotation-entry/reject/${poId}`,
        // PRINT: (id: number) => `/export/po/${id}`,
    },

    STOCK_TRANSFER:{
        FETCH_BY_ID: (id: number) => `/stock-transfer/${id}`,
        CREATE: `/stock-transfer`,
        UPDATE: (id: number) => `/stock-transfer/${id}`,
        APPROVE: (id: number) => `/stock-transfer/approve/${id}`,
        REJECT: (poId: any) => `/stock-transfer/reject/${poId}`,
    }

    
}